export default __webpack_public_path__ + "5a93bd68a59bd914dd4c0ae445371958.png";